module.exports = __webpack_public_path__ + "img/example-left.ed11c9bb.webp";